import {
  Mixins,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import {ITABLECOLCONF} from '@/types/base.d';
import api from '@/api/set';
import publicApi from '@/api/public';
import pageMixin from '../../../../mixins/pageMixin';


@Component
export default class tableMixin extends Mixins(pageMixin) {

  private appDatas: any = [];

  private searchData: any = []

  public form: any = {}; // 表格行数据

  public column: Array<ITABLECOLCONF> = [
    {
      label: '软件名称',
      prop: 'title',
      align: 'center',
    },
    {
      label: '图标',
      prop: 'thumbnail',
      align: 'center',
      custom: true,
      icon: true,
      width: '80px',
    },
    {
      label: '简介',
      align: 'center',
      prop: 'description',
    },
    {
      label: '操作',
      custom: true,
      minWidth: '120',
      maxBtn: 2,
      btnList: [
        {
          title: '上传',
          name: '/set/app:upload',
          icon: 'edit',
          type: 'info',
          callback: this.handleUploadImg,
          log: {
            name: '系统配置 - 编辑',
            component: 'set/tableMixin',
          },
        },
        {
          title: '编辑',
          name: '/set/app:update',
          icon: 'edit',
          type: 'info',
          callback: this.handleUpdateForm,
          log: {
            name: '系统配置 - 编辑',
            component: 'set/tableMixin',
          },
        },
        {
          title: '删除',
          name: '/set/app:delete',
          icon: 'remove',
          type: 'info',
          callback: this.handleRmove,
          log: {
            name: '系统配置 - 删除',
            component: 'set/tableMixin',
          },
        },
      ],
      align: 'center',
    }];

  private loading: boolean = true;

  mounted() {
    this.getData();
  }

  /* eslint-disable class-methods-use-this */
  /**
   * @desc 获取配置列表
   */
  getData() {
    this.loading = true;
    api.getAppData().then((res: any) => {
      this.appDatas = res;
      this.loading = false;
    });
  }

  handleUpdateForm(row) {
  }

  handleUploadImg(row) {

  }


  /**
   * @author ruixue
   * @desc 删除配置操作
   * @param { any } row 行数据
   */
  handleRmove(row: any) {
    this.confirm('此操作将永久删除该数据, 是否继续?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeAppConfig(row.pid).then(() => {
        close();
        this.getData();
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '课时定义 - 删除 - 取消',
      component: 'course/components/tableMixin',
    }));
  }
}
